<template>
  <div class="col-lg-6">
    <div class="card">
      <!-- <div class="card-header">
        <h4 class="card-title">Promjena lozinke</h4>
      </div> -->
      <div class="card-body custom-alert"></div>
      <div class="card-body">
        <validation-observer ref="passwordForm">
          <b-form @submit.prevent="submitForm">
            <b-row>
              <!-- IME -->
              <b-col cols="12">
                <b-form-group label="Ime" label-for="cowName" label-cols-md="4">
                  <validation-provider
                    #default="{ errors }"
                    name="cowName"
                    vid="cowName"
                    rules="required"
                  >
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="AlignRightIcon" />
                      </b-input-group-prepend>

                      <b-form-input
                        v-model="cow.name"
                        id="cowName"
                        type="text"
                        placeholder="Ime grla"
                      />
                    </b-input-group>
                    <div class="text-danger">{{ errors[0] }}</div>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- BROJ NAUSNICE -->
              <b-col cols="12">
                <b-form-group
                  label="Broj naušnice"
                  label-for="cowEarringNumber"
                  label-cols-md="4"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="cowEarringNumber"
                    vid="cowEarringNumber"
                    rules="required"
                  >
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="KeyIcon" />
                      </b-input-group-prepend>

                      <b-form-input
                        v-model="cow.earringNumber"
                        id="cowEarringNumber"
                        type="text"
                        placeholder="Broj naušnice"
                      />
                    </b-input-group>
                    <div class="text-danger">{{ errors[0] }}</div>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- BOJA -->
              <b-col cols="12">
                <b-form-group
                  label="Boja"
                  label-for="cowColor"
                  label-cols-md="4"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="cowColor"
                    vid="cowColor"
                    rules="required"
                  >
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="SunIcon" />
                      </b-input-group-prepend>
                      <b-form-input
                        v-model="cow.color"
                        id="cowColor"
                        type="color"
                        placeholder="Boja grla"
                      />
                    </b-input-group>
                    <div class="text-danger">{{ errors[0] }}</div>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- PRIKAZ NA MAPI -->
              <b-col cols="12">
                <b-form-group
                  label="Prikazuj na mapi"
                  label-for="showOnMap"
                  label-cols-md="4"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="showOnMap"
                    vid="showOnMap"
                  >
                      <b-form-checkbox
                        v-model="cow.showOnMap"
                        id="showOnMap"
                        type="checkbox"
                        placeholder="Prikazuj na mapi"
                      />
                    <div class="text-danger">{{ errors[0] }}</div>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- submit and reset -->
              <b-col offset-md="4">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="mr-1"
                >
                  Sačuvaj
                </b-button>
                <b-button
                  v-if="!$route.params.id"
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  type="reset"
                  variant="outline-secondary"
                  ref="resetButton"
                >
                  Poništi
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BInputGroup,
  BInputGroupPrepend,
  BRow,
  BCol,
  BAlert,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import { heightFade } from "@core/directives/animations";
import { required, min, confirmed } from "@validations";
import store from "@/store/index";
import { mapState } from "vuex";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BAlert,
  },
  directives: {
    "height-fade": heightFade,
    Ripple,
  },
  beforeRouteEnter(to, from, next) {
    let getCowById = null;

    if (!to.params.id) {
      to.meta.pageTitle = "Dodavanje grla";
      to.meta.breadcrumb[1].text = "Dodavanje grla";
      store.commit("devices/SET_COW");
    } else {
      getCowById = store.dispatch("cattle/GET_COW_BY_ID", to.params.id);
      to.meta.pageTitle = "Izmjena grla";
      to.meta.breadcrumb[1].text = "Izmjena grla";
    }

    Promise.all([getCowById]).then(() => {
      next();
    });
  },
  beforeDestroy() {
    store.commit("cattle/SET_COW");
  },
  data() {
    return {};
  },
  mounted() {
    localize("en", {
      code: "en",
      fields: {
        cowName: {
          required: "Polje je obavezno",
        },
        cowColor: {
          required: "Polje je obavezno",
        },
        cowEarringNumber: {
          required: "Polje je obavezno",
        },
      },
    });
  },
  computed: {
    ...mapState({
      cow: (state) => state.cattle.cow,
    }),
  },
  methods: {
    submitForm() {
      var $this = this;
      this.$refs.passwordForm.validate().then((success) => {
        if (success) {
          if (!this.$route.params.id) this.addCow();
          else this.updateCow();
        }
      });
    },
    addCow() {
      var $this = this;
      store
        .dispatch("cattle/ADD_COW", this.cow)
        .then((response) => {
          $this.$swal({
            position: "bottom-end",
            icon: "success",
            title: "Uspješno ste dodali grlo",
            showConfirmButton: false,
            timer: 1500,
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
          $this.$router.push({ name: "CattleIndex" });
        })
        .catch((error) => {});
    },
    updateCow() {
      var $this = this;
      store
        .dispatch("cattle/UPDATE_COW", this.cow)
        .then((response) => {
          $this.$swal({
            position: "bottom-end",
            icon: "success",
            title: "Uspješno ste izmijenili podatke o grlu",
            showConfirmButton: false,
            timer: 1500,
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
          $this.$router.push({ name: "CattleIndex" });
        })
        .catch((error) => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-alert {
  padding-bottom: 0;
}
.form-control:disabled {
  background-color: white;
}
</style>
